import { useState } from "react";
import { IconChevronDown } from "./Icons";

const SelectDropdown = ({
  options = [],
  value,
  onChange,
  placeholder,
  allLabel,
  showAll = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedItem = options.find((opt) => opt.value === value);
  const displayValue = selectedItem ? selectedItem.label : placeholder;

  const handleSelect = (newValue) => {
    onChange(newValue);
    setIsOpen(false);
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        className="filter-btn filter-dropdown-btn"
        onClick={() => setIsOpen(!isOpen)}
      >
        {displayValue} <IconChevronDown />
      </button>
      {isOpen && (
        <div className="all-watches-brand-dropdown">
          {showAll && (
            <div
              className="all-watches-brand-option"
              onClick={() => handleSelect("all")}
            >
              {allLabel}
            </div>
          )}
          {options.map((opt, index) => (
            <div
              key={index}
              className={`all-watches-brand-option ${
                value === opt.value ? "active" : ""
              }`}
              onClick={() => handleSelect(opt.value)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectDropdown;
